import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CentersCentersService } from 'src/app/services/centers-services/centers-centers-service/centers-centers.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Json2csvService } from 'csvtools-lib';

@Component({
  selector: 'app-centers-centers-breadcrumb-card',
  templateUrl: './centers-centers-breadcrumb-card.component.html',
  styleUrls: ['./centers-centers-breadcrumb-card.component.scss']
})
export class CentersCentersBreadcrumbCardComponent implements OnInit {

  @Input() centers;
  filterOpened: boolean;
  viewDisposition;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private userStorageService: UserStorageService,
    private json2csvService: Json2csvService,
    private centersCentersService: CentersCentersService) {
      this.viewDisposition = 'grid';
    }

  ngOnInit() {
    if (this.userStorageService.getFilterCenters()) {
      this.toggleBreadcrumbFilter();
    }
  }

  public toggleViewDisposition(viewDis) {
    this.viewDisposition = viewDis;
    this.centersCentersService.toggleCentersDisposition(viewDis);
  }

  public newCenter() {
    this.router.navigate(['../center'], { relativeTo: this.activatedRoute.parent });
  }

  public toggleBreadcrumbFilter() {
    this.filterOpened = !this.filterOpened;
  }

  public search(event) {
    this.centersCentersService.searchCenters(event.target.value);
  }

  public exportCentersList() {
    this.centers.forEach(i => i['street'] = (i['street'] !== null ? i['street'].replace(',', ' ') : i['street'] ));
    this.centers.forEach(i => i['fiscalAddress'] = (i['fiscalAddress'] !== null ? i['fiscalAddress'].replace(',', ' ') : i['fiscalAddress']));
    this.json2csvService.setBody(this.centers, ['centerName', 'street', 'cif', 'fiscalName', 'fiscalAddress', 'phoneNumber', 'faxNumber', 'zipCode', 'city', 'province', 'region', 'country', 'centerMail', 'centerContactName']);
    this.json2csvService.setHeader(['Center', 'Street', 'ID', 'Fiscal name', 'Fiscal address', 'Phone number', 'Fax number', 'Zip code', 'City', 'Province', 'Region', 'Country', 'Center email', 'ContactName']);
    this.json2csvService.generateCSV('centerList');
  }

}
